module.exports = __webpack_public_path__ + "img/白蔹.ce288d37.jpg";